import {
  ADD_WHITELISTED_ADDRESS,
  ADD_WHITELISTED_ADDRESS_ERROR,
  ADD_WHITELISTED_ADDRESS_SUCCESS,
  FETCH_TOKEN_STATUS,
  FETCH_TOKEN_STATUS_ERROR,
  FETCH_TOKEN_STATUS_SUCCESS,
  REMOVE_WHITELISTED_ADDRESS_SUCCESS,
  TokenStatusActionTypes,
  UPDATING_TOKEN_STATUS,
  UPDATING_TOKEN_STATUS_ERROR,
  UPDATING_TOKEN_STATUS_SUCCESS,
  REMOVE_WHITELISTED_ADDRESS,
  REMOVE_WHITELISTED_ADDRESS_ERROR,
} from '../../../types/actions/Token/Status.actions';
import {ITokenStatus} from '../../../types/models/Token';

export interface TokenStatusState {
  data: ITokenStatus | null;
  isLoading: boolean;
  isUpdating: boolean;
  isSaving: boolean;
}

const initialState: TokenStatusState = {
  isLoading: false,
  isUpdating: false,
  isSaving: false,
  data: null,
};

export default (
  state = initialState,
  action: TokenStatusActionTypes,
): TokenStatusState => {
  switch (action.type) {
    case FETCH_TOKEN_STATUS: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case FETCH_TOKEN_STATUS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };
    }

    case FETCH_TOKEN_STATUS_ERROR: {
      return {
        ...state,
        isLoading: false,
        data: null,
      };
    }

    case ADD_WHITELISTED_ADDRESS_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        data: {
          ...(state.data as ITokenStatus),
          whitelistedAddresses: [
            ...state.data!.whitelistedAddresses,
            action.payload,
          ],
        },
      };
    }

    case REMOVE_WHITELISTED_ADDRESS_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        data: {
          ...(state.data as ITokenStatus),
          whitelistedAddresses: state.data!.whitelistedAddresses.filter(
            (addr) => addr !== action.payload,
          ),
        },
      };
    }

    case ADD_WHITELISTED_ADDRESS:
    case REMOVE_WHITELISTED_ADDRESS:
      return {...state, isSaving: true};

    case ADD_WHITELISTED_ADDRESS_ERROR:
    case REMOVE_WHITELISTED_ADDRESS_ERROR:
      return {...state, isSaving: false};

    case UPDATING_TOKEN_STATUS:
      return {...state, isUpdating: true};

    case UPDATING_TOKEN_STATUS_ERROR:
    case UPDATING_TOKEN_STATUS_SUCCESS:
      return {...state, isUpdating: false};

    default:
      return state;
  }
};
